<template>
  <div class="cmp-accounting-invoices-mandatory-info selectedInvoice-info dbox">
    <Dropdown2
      :label="$t('invoice_project')"
      :placeholder="$t('select')+' ' + $t('invoice_project')"
      :disabled="selectedInvoice.disabled"
      :options="selectedInvoice.invoice_projectsTV"
      :selected="
        selectedInvoice.invoice_projectsTV.find(
          (c) => c.value == selectedInvoice.invoice.invoice_project_id
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
    />
    <Checkbox2
      :disabled="selectedInvoice.disabled"
      :id="'display_correction'"
      :label="$t('invoice_correction')"
      :value="selectedInvoice.invoice.display_correction"
      :placeholder="$t('invoice_correction')"
      @input="onCheckboxChange"
    />
    <TextField2
      :disabled="selectedInvoice.disabled"
      :id="'invoice_ref'"
      :placeholder="$t('invoice_no')"
      :label="$t('invoice_no')"
      :value="selectedInvoice.invoice.invoice_ref"
      @blur="onTextFieldValueChange"
    />
    <DatePicker2
      :disabled="selectedInvoice.disabled"
      id="invoice_date"
      :label="$t('date')"
      :value="selectedInvoice.invoice.invoice_date"
      @input="onDateUpdate"
    />
    <Dropdown2
      :label="$t('currency')"
      :placeholder="$t('select')+' ' + $t('currency')"
      :disabled="selectedInvoice.disabled"
      :options="selectedInvoice.currenciesTV"
      :selected="
        selectedInvoice.currenciesTV.find(
          (c) => c.value == selectedInvoice.invoice.currency_id
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('currency_id', e)"
    />
    <DatePicker2
      :disabled="selectedInvoice.disabled"
      id="performance_date"
      :label="$t('performance_date')"
      :value="selectedInvoice.invoice.performance_date"
      @input="onDateUpdate"
    />
    <TextField2
      :disabled="selectedInvoice.disabled"
      :id="'performance_country'"
      :placeholder="$t('performance_place')"
      :label="$t('performance_place')"
      :value="selectedInvoice.invoice.performance_country"
      @change="onTextFieldValueChange"
    />
    <!-- <TextField2
      :disabled="selectedInvoice.disabled"
      :id="'vat_territory'"
      :placeholder="$t('vat_territory')"
      :label="$t('vat_territory')"
      :value="selectedInvoice.invoice.vat_territory"
      @change="onTextFieldValueChange"
    /> -->
    <div class="fc2 fc2-row ut-flex">
      <div style="display: flex; margin-right: 7px;align-items: center;">
        <label class="fc2-label txtov"
          >{{ $t("vat_territory") }}
        </label>
        <div @click="openModal" class="dt-icon-container">
          <img src="static/icons/lupe-blue.svg" class="dt-icon v5 s3" alt />
        </div>
      </div>
      <div class="ut-flex no-left-padding">
        <TextField2
          bb="0px"
          :disabled="selectedInvoice.disabled"
          :id="'vat_territory'"
          :placeholder="$t('vat_territory')"
          :label="$t('vat_territory')"
          :showLabel="false"
          :value="selectedInvoice.invoice.vat_territory"
          @change="onTextFieldValueChange"
        />
      </div>
    </div>
    <Dropdown2
      :label="$t('invoice_language')"
      :placeholder="$t('select')+' ' + $t('invoice_language')"
      :disabled="selectedInvoice.disabled"
      :options="selectedInvoice.languagesTV"
      :selected="
        selectedInvoice.languagesTV.find(
          (c) => c.value == selectedInvoice.invoice.invoice_language
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('invoice_language', e)"
    />

    <Dropdown2
      :label="$t('staff')"
      :placeholder="$t('select')+' ' + $t('staff')"
      :disabled="selectedInvoice.disabled"
      :options="selectedInvoice.usersTV"
      :selected="
        selectedInvoice.usersTV.find(
          (c) => c.value == selectedInvoice.invoice.invoice_user_id
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('invoice_user_id', e)"
      bb="0px"
    />

    <!-- <div class="form-group">
      <Dropdown
        :disabled="selectedInvoice.disabled"
        class="dt-dropdown m1"
        :options="selectedInvoice.invoice_projectsTV"
        :selected="selectedInvoice.invoice_projectsTV.find(c => c.value == selectedInvoice.invoice.invoice_project_id)"
        box
        :placeholder="$t('invoice_project')"
        v-on:selectedChange="e => onDropdownChange('invoice_project_id', e)"
        :listHeight="150"
      ></Dropdown>
      <Dropdown
        :disabled="selectedInvoice.disabled"
        class="dt-dropdown m1"
        :options="selectedInvoice.currenciesTV"
        :selected="selectedInvoice.currenciesTV.find(c => c.value == selectedInvoice.invoice.currency_id)"
        box
        :placeholder="$t('currency')"
        v-on:selectedChange="e => onDropdownChange('currency_id', e)"
        :listHeight="150"
      ></Dropdown>
      <Dropdown
        :disabled="selectedInvoice.disabled"
        class="dt-dropdown m1"
        :options="selectedInvoice.usersTV"
        :selected="selectedInvoice.usersTV.find(c => c.value == selectedInvoice.invoice.invoice_user_id)"
        box
        :placeholder="$t('staff')"
        v-on:selectedChange="e => onDropdownChange('invoice_user_id', e)"
        :listHeight="150"
      ></Dropdown>
      <TextField
          :disabled="selectedInvoice.disabled"
          :id="'invoice_ref'"
          v-bind="textFieldConfig"
          :value="selectedInvoice.invoice.invoice_ref"
          :placeholder="$t('invoice_no')"
          @valuechanged="onTextFieldValueChange"
        />
      <DatePicker
          :disabled="selectedInvoice.disabled"
          id="invoice_date"
          :value="selectedInvoice.invoice.invoice_date"
          @valuechanged="onDateUpdate"
        />
      <Dropdown
        :disabled="selectedInvoice.disabled"
        class="dt-dropdown m1"
        :options="selectedInvoice.languagesTV"
        :selected="selectedInvoice.languagesTV.find(c => c.value == selectedInvoice.invoice.invoice_language)"
        box
        :placeholder="$t('invoice_language')"
        v-on:selectedChange="e => onDropdownChange('invoice_language', e)"
        :listHeight="150"
      ></Dropdown>
      <DatePicker
          :disabled="selectedInvoice.disabled"
          id="performance_date"
          :placeholder="$t('performance_date')"
          :value="selectedInvoice.invoice.performance_date"
          @valuechanged="onPerformanceDateUpdate"
        />
      <TextField
          :disabled="selectedInvoice.disabled"
          :id="'performance_country'"
          v-bind="textFieldConfig"
          :value="selectedInvoice.invoice.performance_country"
          :placeholder="$t('performance_place')"
          @valuechanged="onTextFieldValueChange"
        />
    </div>
    -->
  </div>
</template>

<script>
import { EventHooks } from "../../../../plugins/text-field";
import { createCountriesTV } from "../../../../models/country.model";
import { createLanguageTV } from "../../../../models/language.model";
import { tv } from "../../../../models/text-value.model";
import { createUserTV } from "../../../../models/user.model";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { createCurrencyTV } from "../../../../models/currency.model";

export default {
  components: {},
  props: {
    selectedInvoice: {
      required: true,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
    };
  },
  mounted: function () {
    console.log("WEEEEEEEE", this.selectedInvoice.invoice.vat_handling);
  },
  computed: {},
  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onCheckboxChange: function ({ name, value }) {
      console.log("WWWWWWqqqqqqqqqqqq", name, value);
      this.$emit("changed", {
        name,
        value: value ? "1" : "0",
      });
    },
    onDropdownChange: function (name, value) {
      console.log("WWWWWWqqqqqqqqqqqq", name, value);
      this.$emit("changed", { name, value: value.value });
    },
    onDateUpdate: function ({ name, value }) {
      // console.log(name, value);
      this.$emit("changed", { name, value });
    },
    openModal() {
      openModalRoute(this, "vat_territory_modal", {
        mode: "add",
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-accounting-invoices-mandatory-info {
  .fc2-row {
    --bb: 1px solid var(--sprt-85);
    height: 30px;
    //border-bottom: var(--bb);

    .fc2-label,
    .icon,
    .title {
      flex: 1;
    }
    .fc2-label,
    .title-txt {
      max-width: 115px;
    }
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;

      &.no-left-padding {
        padding-left: 0;
      }

      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .fc2-textfield {
      width: 100%;
    }
    .icon {
      min-height: 22px;
      justify-content: flex-end;
    }
  }
}
</style>
